import { Component } from 'react';
import LookupItemService from '../Services/LookupItemService';

class LookupTextLookupItemIdArray extends Component {
    static defaultProps={
        lookupId:23,
        valueArray: [],
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            text:""
        };
    }

    componentDidMount() 
    {
        LookupItemService.GetLookupItemByLookupIdAndLookupItemIdValueArray(this.props.lookupId, this.props.valueArray)
        .then(result=>this.setState({text:result.text}))
        .catch(error=>this.setState({text:""}));
    }

    render()
    {
        return this.state.text ;
    }
}
 
export default LookupTextLookupItemIdArray;